import { Booking } from '../../api/dtos/Booking.schema'
import { BookingDetails } from '../../api/dtos/BookingDetails.schema'
import store from '@/store'
import * as bookingApi from '@/api/bookings'
import { RentalStatus } from '@/api/dtos/RentalStatus.schema'
import {
  Module,
  VuexModule,
  Mutation,
  Action,
  MutationAction,
  getModule
} from 'vuex-module-decorators'

export interface IBookingStoreState {
  detailedBooking: BookingDetails | null
  bookings: Booking[]
}

@Module({ dynamic: true, store, name: 'bookings' })
class Bookings
  extends VuexModule
  implements IBookingStoreState {
  public detailedBooking: BookingDetails | null = null
  public bookings: Booking[] = []

  @MutationAction({ mutate: ['bookings'] })
  public async fetchBookings (filter: {
    start: Date;
    end: Date;
    stationIds?: string[];
    deviceIds?: string[];
    status?: RentalStatus;
  }): Promise<{
    bookings: Booking[]
  }> {
    return {
      bookings: await bookingApi.getBookings(
        filter.start,
        filter.end,
        filter.stationIds,
        filter.deviceIds,
        filter.status
      )
    }
  }

  @MutationAction({ mutate: ['detailedBooking'] })
  public async fetchDetailedBooking (
    bookingId: string
  ): Promise<{ detailedBooking: BookingDetails }> {
    return {
      detailedBooking: await bookingApi.getBookingDetails(bookingId)
    }
  }

  @MutationAction({ mutate: ['detailedBooking'] })
  public async refreshDetailedBooking (): Promise<{
    detailedBooking: BookingDetails
  }> {
    if (!this.detailedBooking) {
      throw Error('no detailed booking to refresh present!')
    }
    return {
      detailedBooking: await bookingApi.getBookingDetails(
        this.detailedBooking.bookingId
      )
    }
  }
}

export const BookingsModule = getModule(Bookings)
